<template>
  <v-dialog persistent v-model="value" max-width="1100px" scrollable>
    <desition
      @desition="$event ? clearDataPoll() : ''"
      v-model="showDeleteFormModal"
      title="Eliminar cita"
      description="¿Está seguro que desea realizar dicha acción? Este proceso es irreversible y no podrá recuperar la información"
    />

    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Crear cita</span>
      </v-card-title>
      <v-card-text style="max-height: 700px" id="PopupContainer">
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1"
                  >Generales</v-stepper-step
                >

                <v-divider v-if="showAudience()" />
                <v-stepper-step
                  v-if="showAudience()"
                  :complete="showAudience() ? e1 > 2 : e1 > 10"
                  :step="showAudience() ? 2 : 10"
                  >Invitados externos</v-stepper-step
                >

                <v-divider v-if="visitForm.peopleMode === 'MANUAL'" />
                <v-stepper-step
                  v-if="visitForm.peopleMode === 'MANUAL'"
                  :complete="showAudience() ? e1 > 3 : e1 > 2"
                  :step="showAudience() ? 3 : 2"
                  >Invitados internos</v-stepper-step
                >

                <v-divider />
                <v-stepper-step
                  :step="
                    showAudience()
                      ? visitForm.peopleMode === 'MANUAL'
                        ? 4
                        : 3
                      : 3
                  "
                  >Previo</v-stepper-step
                >
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <v-layout wrap row justify-center cPoll>
                    <v-flex xs12 md10 lg8>
                      <VisitForm
                        :visitForm="visitForm"
                        :collaborators="collaborators"
                        @formMounted="onMountedForm"
                        @onCollaboratorSelected="onCollaboratorSelected"
                        @chipData="chipData"
                      />

                      <v-btn
                        style="text-transform: none; margin-bottom: 30px"
                        @click="
                          displayPoolForm(showPollForm, 'Añadir', visitPollForm)
                        "
                        v-if="showPollButton()"
                      >
                        <!--v-if="showPollForm"-->
                        <v-icon color="primary">add</v-icon>
                        Añadir encuesta de salud
                      </v-btn>

                      <v-layout wrap row v-if="!displayPollBtn">
                        <v-btn
                          style="text-transform: none; margin-bottom: 30px"
                        >
                          <!--v-if="showPollForm"-->
                          <v-icon color="primary">poll</v-icon>
                          Encuesta de salud
                        </v-btn>

                        <v-btn
                          icon
                          @click="
                            displayPoolForm(
                              showPollForm,
                              'Guardar cambios',
                              visitPollForm
                            )
                          "
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>

                        <v-btn icon @click="showModalOnDelete()">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-layout>

                      <!--ENCUESTA-->
                      <VisitPollStatus
                        @formIsOpen="formIsOpen"
                        @alreadyHavePoll="alreadyHavePoll"
                        @updatePollForm="updatePollForm"
                        @clearPollForm="clearPollForm"
                        :visitPollForm="visitPollForm"
                        ref="pollStatus"
                      />
                    </v-flex>
                  </v-layout>
                </v-stepper-content>

                <v-stepper-content
                  v-if="visitForm.peopleMode === 'MANUAL'"
                  :step="showAudience() ? 3 : 2"
                >
                  <PollAudience
                    :userPermissions="userPermissions"
                    :cancel="flags.cancel"
                    @selected="selectionAudiency"
                  />
                </v-stepper-content>

                <v-stepper-content
                  v-if="visitForm.peopleMode === 'MANUAL'"
                  :step="showAudience() ? 2 : 10"
                >
                  <v-layout wrap row justify-center>
                    <v-flex xs12 md12 lg12>
                      <VisitExternPeople
                        :people="people"
                        @addedPerson="addedPerson"
                        @editedPerson="editedPerson"
                      />
                    </v-flex>
                  </v-layout>
                </v-stepper-content>

                <v-stepper-content
                  v-if="visitForm.peopleMode === 'AUDIENCE'"
                  :step="2"
                >
                  <PollAudience
                    :userPermissions="userPermissions"
                    :cancel="flags.cancel"
                    :_object="visitForm"
                    @selected="selectionAudiency"
                  />
                </v-stepper-content>

                <v-stepper-content
                  :step="
                    showAudience()
                      ? visitForm.peopleMode === 'MANUAL'
                        ? 4
                        : 3
                      : 3
                  "
                >
                  <VisitDetail
                    :visit="visitForm"
                    :people="people"
                    :collaborator="collaborator"
                  />
                </v-stepper-content>
              </v-stepper-items>
              <alert
                v-model="toast.alert"
                title="Aviso"
                :description="toast.description"
              ></alert>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="disabled && e1 == 1"
          :disabled="e1 == 1"
          @click="back"
          flat
        ></v-btn>
        <v-btn v-if="e1 != 1" @click="back" flat>Anterior</v-btn>

        <v-spacer></v-spacer>

        <v-btn v-if="disabled" @click="close" flat>Cancelar</v-btn>

        <v-spacer></v-spacer>

        <v-btn
          v-if="
            disabled && (showAudience() ? e1 != 4 : e1 != 3) && !disabledOnPoll
          "
          @click="next"
          color="primary"
          flat
        >
          Siguiente
        </v-btn>

        <v-btn
          v-if="disabled && (showAudience() ? e1 == 4 : e1 == 3)"
          @click="next"
          class="primary text-white"
          outlined
          flat
        >
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>

    <div data-app>
      <alerta
        v-model="modals.alert"
        :text="modals.Clave"
        :title="modals.Title"
        :cond="modals.Cond"
        @cancelled="onCancelAlert"
        @continue="onContinueAlert"
      ></alerta>
    </div>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import alert from '../../Dialogs/Alert'
import desition from '../../Dialogs/Confirm'
import PollAudience from '../../Tools/AudienceVisits.vue'
import VisitDetail from './VisitDetailV2'
import VisitExternPeople from './VisitExternPeopleV2'
import VisitForm from './VisitFormV2'
import VisitParentSelector from './VisitParentSelector'
import alerta from './VisitPollAlert'
import VisitPollStatus from './VisitPollStatus'

export default {
  components: {
    VisitForm,
    VisitParentSelector,
    VisitExternPeople,
    VisitDetail,
    alert,
    PollAudience,
    desition,
    VisitPollStatus,
    alerta,
  },

  props: ['value', 'poll', 'collaborators', 'userPermissions'],
  watch: {},
  data: () => ({
    disabledBtn: true,
    modals: {
      alert: false,
      Clave:
        'Al continuar sin añadir la encuesta, esta no se incluirá en tu cita ¿Deseas continuar sin añadirla?',
      Title: '',
      Cond: true,
    },
    msg: '',
    showPollForm: true,
    displayPollBtn: true,
    showDeleteFormModal: false,
    e1: 0,
    pollF: {
      poll: [],
    },
    isPollFormOpen: false,
    visitForm: {
      name: '',
      reason: '',
      area: '',
      collaborators: [],
      collaboratorNames: [],
      date: null,
      startDate: null,
      endDate: null,
      students: [],
      levels: [],
      groups: [],
      tutors: [],
      webRoleIds: [],
      hasPoll: false,
      peopleMode: 'MANUAL',
      audience: {
        institutional: false,
      },
      visitType: 'ONLY_ONCE',
    },

    addText: 'Añadir',
    collaborator: null,
    people: {
      parents: [],
      externs: [],
      nparents: [],
      nColaborators: [],
    },
    toast: {
      alert: false,
      description: '',
    },
    flags: {
      cancel: false,
    },
    disabled: true,
    disabledOnPoll: false,
    vueForm: null,
    visitPollForm: {
      questions: [
        {
          question: '¿Usted presenta algunos de los siguientes síntomas?',
          type: 'MULTIPLE',
          answers: [
            { answer: 'Tos seca' },
            { answer: 'Dolor de cabeza' },
            { answer: 'Dificultad para respirar' },
            { answer: 'Malestar general' },
            { answer: 'Dolor de garganta' },
            { answer: 'Temperatura' },
            { answer: 'No presenta síntomas' },
          ],
        },
      ],

      theEmailsToNotify: [],
      notifyByEmail: false,
      requiredForEntry: false,
    },
  }),
  computed: {
    ...mapGetters(['getBranch', 'getStatusIsEmail']),
  },
  methods: {
    showAudience() {
      if (!isNormalSchool(this.getBranch)) {
        return false
      } else {
        return this.visitForm.peopleMode === 'MANUAL'
      }
    },
    showPollButton() {
      if (!isNormalSchool(this.getBranch)) {
        return false
      } else {
        return this.displayPollBtn
      }
    },
    chipData(data, collaboratorNames) {
      this.visitForm.collaborators = data
      this.visitForm.collaboratorNames = collaboratorNames
    },
    onCancelAlert() {
      this.modals.alert = false
    },

    onContinueAlert() {
      this.modals.alert = false
      this.isPollFormOpen = false
      this.$refs.pollStatus.clearData()
      this.next()
    },

    displayPoolForm(value, info, visitPollForm) {
      this.$refs.pollStatus.displayForm(value, info, visitPollForm)
      this.disabledOnPoll = true
    },

    showModalOnDelete() {
      this.showDeleteFormModal = true
    },

    clearDataPoll() {
      this.$refs.pollStatus.clearData()
    },

    formIsOpen(value) {
      this.isPollFormOpen = value
      this.disabledOnPoll = false
    },

    alreadyHavePoll(value) {
      this.displayPollBtn = !value.displayBtn
    },

    updatePollForm(value) {
      this.visitPollForm = value //Obtengo el valor de la encuesta creada por si se vuelve a editar
      this.visitForm.pollRequest = this.visitPollForm
      this.visitForm.hasPoll = true
    },

    clearPollForm() {
      delete this.visitForm['pollRequest']
      this.visitForm.hasPoll = false
    },

    addedPerson(person) {
      this.people.externs.push(person)
    },
    addedTutor() {},
    editedPerson(index, person) {
      this.people.externs[index] = person
    },

    onSelectParent(parents) {
      this.people.parents = parents
    },
    onCollaboratorSelected(collaborator) {
      this.collaborator = collaborator
    },
    onMountedForm(form) {
      this.vueForm = form
    },
    selectionAudiency(event) {
      this.visitForm.levels = event.levels
      this.visitForm.groups = event.ggs
      this.visitForm.students = event.students
      this.visitForm.tutors = event.tutors
      this.visitForm.webRoleIds = event.webRoleIds
      this.visitForm.audience.institutional = event.institutional
      // console.log("event selectionAudiency", event)
    },
    close() {
      this.flags.cancel = true
      this.e1 = 1
      this.$emit('onClosed', false)
    },

    next() {
      switch (this.e1) {
        case 1:
          this.vueForm.$touch()
          if (!this.vueForm.$invalid) {
            if (this.isPollFormOpen) {
              this.modals.alert = true
            } else {
              this.e1++
            }
          }
          break
        case 2:
          if (this.visitForm.peopleMode === 'MANUAL') {
            if (!this.showAudience()) {
              if (this.people.externs.length > 0) {
                this.e1++
              } else {
                this.toast.description =
                  'Debes agregar ya sea la institución o al menos un nivel, grupo o estudiante'
                this.toast.alert = true
              }
            } else {
              this.e1++
            }
          } else if (
            this.visitForm.students.length > 0 ||
            this.visitForm.groups.length > 0 ||
            this.visitForm.levels.length > 0 ||
            this.visitForm.audience.institutional
          ) {
            this.e1++
          } else {
            this.toast.description =
              'Debes agregar ya sea la institución o al menos un nivel, grupo o estudiante'
            this.toast.alert = true
          }
          break
        case 3:
          if (!this.showAudience()) {
            this.createVisit()
          } else {
            if (this.visitForm.peopleMode === 'MANUAL') {
              let arrEmails = []
              let arrNames = []
              let arrLastNames = []
              let emailReg =
                /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])$/i

              this.people.externs.forEach((element) => {
                arrEmails.push(element.email)
              })
              this.people.externs.forEach((element) => {
                arrNames.push(element.firstName)
              })
              this.people.externs.forEach((element) => {
                arrLastNames.push(element.lastName)
              })
              console.log('invitados', this.people.externs)
              if (
                this.visitForm.students.length > 0 ||
                this.visitForm.groups.length > 0 ||
                this.visitForm.levels.length > 0 ||
                this.visitForm.tutors.length > 0 ||
                this.people.externs.length > 0 ||
                this.visitForm.webRoleIds.length > 0 ||
                this.visitForm.audience.institutional
              ) {
                this.e1++
              } else {
                this.toast.description =
                  'Debes agregar al menos a un invitado del colegio o un invitado externo'
                this.toast.alert = true
              }

              arrEmails.forEach((adress) => {
                console.log(adress)
                let arrs = emailReg.test(adress)
                if (adress === '') {
                  arrs = true
                }
                if (arrs) {
                  console.log('puedes pasar')
                } else {
                  this.toast.description =
                    'Revisa que los correos de los invitados externos sean correctos'
                  this.toast.alert = true
                  this.e1 = 3
                }
              })

              arrNames.forEach((name) => {
                console.log(name)
                if (name != null) {
                  console.log('puedes pasar')
                } else {
                  this.toast.description =
                    'El nombre de los invitados externos es obligatorio'
                  this.toast.alert = true
                  this.e1 = 3
                }
              })

              arrLastNames.forEach((lastName) => {
                console.log(lastName)

                if (lastName != null) {
                  console.log('puedes pasar')
                } else {
                  this.toast.description =
                    'El apellido de los invitados externos es obligatorio'
                  this.toast.alert = true
                  this.e1 = 3
                }
              })
            } else {
              this.createVisit()
            }
          }
          break
        case 4:
          this.createVisit()

          break
      }
    },
    back() {
      this.e1--
    },

    createVisit() {
      this.disabled = false
      this.$emit('loading', true)

      let visit = {
        name: this.visitForm.reason,
        collaborators: this.visitForm.collaborators,
        reason: this.visitForm.reason,
        date: null,
        startDate: null,
        endDate: null,
        area: this.visitForm.area,
        visitType: this.visitForm.visitType,
      }

      if (visit.visitType === 'RANGE') {
        visit.startDate = moment(this.visitForm.startDate).utc(false).valueOf()
        visit.endDate = moment(this.visitForm.endDate).utc(false).valueOf()
      } else {
        visit.date = moment(this.visitForm.date).utc(false).valueOf()
      }

      if (this.visitForm.peopleMode === 'MANUAL') {
        visit.people = (this.people.parents || []).map(function (parent) {
          return {
            idParent: parent.id,
            firstName: parent.firstName,
            lastName: parent.lastName,
            email: parent.mail,
            phone: parent.phone,
          }
        })

        var externs = (this.people.externs || []).map(function (extern) {
          return {
            firstName: extern.firstName,
            lastName: extern.lastName,
            email: extern.email,
            phone: extern.phone,
          }
        })

        visit.people = visit.people.concat(externs)

        var nParents = (this.visitForm.tutors || []).map(function (nparents) {
          return {
            idParent: nparents.id,
            firstName: nparents.firstName,
            lastName: nparents.lastName,
            email: nparents.mail,
          }
        })

        visit.pollRequest = this.visitForm.pollRequest

        visit.parents = nParents
        visit.webRoleIds = (this.visitForm.webRoleIds || []).map((rl) => rl.id)
        visit.institutional = this.visitForm.audience.institutional
        visit.levelIds = (this.visitForm.levels || []).map((lvl) => lvl.id)
        visit.gradeGroupIds = (this.visitForm.groups || []).map((gg) => gg.id)
        visit.studentIds = (this.visitForm.students || []).map((std) => std.id)
      }
      //Esto se usaba cuando no eran manual la creación de cita
      else {
        visit.institutional = this.visitForm.audience.institutional
        visit.levelIds = (this.visitForm.levels || []).map((lvl) => lvl.id)
        visit.gradeGroupIds = (this.visitForm.groups || []).map((gg) => gg.id)
        visit.studentIds = (this.visitForm.students || []).map((std) => std.id)
      }

      this.$store
        .dispatch('visits/createVisit', visit)
        .then((response) => {
          GoogleAnalytics.actionEvent({
            eventName: 'created_visit',
            eventDescription: 'Visita creada',
          })
          this.disabled = true
          this.close()
          this.$emit('created', { success: true, visit: response.data })
        })
        .catch((error) => {
          this.disabled = true
          this.$emit('created', { success: false, error: error })
        })
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.close()
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
}
</script>

<style></style>
